
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { [key: string]: Record<string, string> };
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    // 合并翻译内容
    Object.keys(module).forEach((key) => {
      if (key !== 'default') {
        messages[lang].translation = {
          ...messages[lang].translation,
          ...module[key]
        };
      }
    });
  }
});

export default messages;
